function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-farm-dash---operations-multiselection",
  transform: "translate(-192.000000, -201.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(192.000000, 201.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-25",
  fill: "#299D74",
  x: 0,
  y: 0,
  width: 19,
  height: 19
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#F8F9FB",
  x: 4,
  y: 8,
  width: 11,
  height: 3
}))));

function SvgCheckboxHeaderSelected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxHeaderSelected);
export default __webpack_public_path__ + "static/media/checkbox-header-selected.46759d1f.svg";
export { ForwardRef as ReactComponent };